import * as emojione from 'emojione';

export function replaceUnicode(source) {
    if (source != null && typeof source === 'string' && source.trim().length > 0) {
        return emojione.toShort(source);
    }

    return source;
}

export function replaceShortcodes(source) {
    if (source != null && typeof source === 'string' && source.trim().length > 0) {
        return emojione.shortnameToImage(source);
    }

    return source;
}


// WEBPACK FOOTER //
// ./src/app/utils/emojify.js